import { render, staticRenderFns } from "./promotion-rag-colours.vue?vue&type=template&id=dfc8cda4&scoped=true&functional=true"
import script from "./promotion-rag-colours.vue?vue&type=script&lang=js"
export * from "./promotion-rag-colours.vue?vue&type=script&lang=js"
import style0 from "./promotion-rag-colours.vue?vue&type=style&index=0&id=dfc8cda4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "dfc8cda4",
  null
  
)

export default component.exports